import React from 'react';

// Clickable chips to choose which payment methods appear on the invoice PDF
export const PaymentMethodChips = ({ methods = [], selected = [], onChange, testPrefix = 'pm' }) => {
  if (!methods.length) return <p className="text-xs text-muted-foreground">Añade métodos de pago en Admin → Datos de facturación.</p>;
  const toggle = (id) => onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  return (
    <div className="flex flex-wrap gap-2">
      {methods.map((m) => {
        const on = selected.includes(m.id);
        return (
          <button
            key={m.id}
            type="button"
            onClick={() => toggle(m.id)}
            title={m.text.replace(/\*\*/g, '')}
            className={`px-3 py-1.5 rounded-full border text-xs font-medium transition-colors ${on ? 'bg-primary text-white border-primary' : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-50'}`}
            data-testid={`${testPrefix}-${m.id}`}
          >
            {on ? '✓ ' : ''}{m.name}
          </button>
        );
      })}
    </div>
  );
};

export default PaymentMethodChips;
